/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/formatMoney.js":
/*!*******************************!*\
  !*** ./src/js/formatMoney.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatMoney: () => (/* binding */ formatMoney)
/* harmony export */ });
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------

function formatMoney(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || "${{amount}}";
  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }
  return formatString.replace(placeholderRegex, value);
}
;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
(() => {
/*!***************************!*\
  !*** ./src/js/product.js ***!
  \***************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _formatMoney__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./formatMoney */ "./src/js/formatMoney.js");
// import Zoom from "smooth-zoom";


/*
 BG: Init smooth-zoom, just apply the class below a zoomable image
https://github.com/marshall-ku/smooth-zoom
 */
// Zoom(".zoomable");

/**
 * BG: This is a BIG function, that has alot of smaller functions. The whole purpose of this is to determine the variant options the user has selected, while highlighting the available and unavailable variants after each choice they make, and updating the price, and variant id field. This function works best when we have the first available variants selected.
 */

var productVariants = function productVariants() {
  var productVariants = document.querySelector("#product-variants");
  var radioBtns = productVariants.querySelectorAll('input[type="radio"]');
  var variantFieldsets = productVariants.querySelectorAll("fieldset:not(.js-manual-variants)");
  var masterVariantField = document.querySelector('.product-info form[action*="/cart/add"] input[name="id"]');
  var cartBtn = document.querySelector('.product-info form[action*="/cart/add"] button[type="submit"]');

  // const productHandle = document.querySelector(".product-info").dataset.productHandle;

  var paymentBtns = document.querySelector(".js-payment-buttons");
  var inStockNotification = document.querySelector(".js-in-stock");
  var lowStockNotification = document.querySelector(".js-low-stock");
  var noStockNotification = document.querySelector(".js-sold-out");
  var colourVariants = document.querySelectorAll(".js-colour-variant");
  var stickyVariants = document.querySelector(".js-sticky-variants");
  var stickyVariantValue = document.querySelector(".js-sticky-selection");

  //get the variantData from the json markup.
  var getVariantData = function getVariantData() {
    return JSON.parse(productVariants.querySelector('[type="application/json"]').textContent);
  };

  //Debug
  //console.log(JSON.parse(productVariants.querySelector('[type="application/json"]').textContent));

  //BG: When the user makes a selection, update the field legend to include that choice.
  /**
   *
   * @param {*} radio | Node - Passed when the user selects a radio on variant selector.
   */
  var fieldsetLegend = function fieldsetLegend(radio) {
    var parentLegend = radio.closest("fieldset");
    var legendLabel = parentLegend.querySelector("legend").getAttribute("data-fieldset-label");
    var legendCurrent = parentLegend.querySelector("legend").getAttribute("data-current-variant");
    // console.log(radio);
    parentLegend.querySelector("legend").innerHTML = "".concat(legendLabel, ": <span class=\"text-[12px]\">").concat(radio.value, "</span>");
    if (!!legendCurrent) {
      parentLegend.querySelector("legend").dataset.currentVariant = radio.value;
    }
  };

  //BG: Triggered by the finalVariant function, we determine if the final variant Id selected is available or not, and update the button to reflect that choice.
  var addToBagBtn = function addToBagBtn(available) {
    if (available) {
      if (cartBtn) cartBtn.classList.remove("btn-disabled");
      cartBtn.classList.add("btn-primary");
      cartBtn.querySelector(".js-button-text").innerHTML = window.product.addToCart;
      cartBtn.classList.remove("hidden");
      cartBtn.disabled = false;
      paymentBtns.classList.remove("hidden");
      document.querySelector(".js-sticky-buy button").disabled = false;
    } else {
      paymentBtns.classList.add("hidden");
      cartBtn.classList.add("btn-disabled");
      cartBtn.classList.remove("btn-primary");
      document.querySelector(".js-sticky-buy button").disabled = true;
    }
  };

  //BG: the finalVariant funciton below will trigger this function, we essentially need the variant ID to query the price
  var variantPrice = function variantPrice(variantId) {
    var productPrice = document.querySelectorAll(".js-product-price");
    var productCAPs = document.querySelectorAll(".js-product-compare-at-price");
    var productDiscounts = document.querySelectorAll(".js-pdp-saving");
    var variantData = getVariantData().filter(function (variant) {
      return variant.id === variantId;
    });

    // Update the product price, with the selected variant, and format the money.
    productPrice.forEach(function (price) {
      price.innerHTML = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(variantData[0].price, window.theme.moneyFormat);
    });

    // Is there a Compare at price (CAP)? if so, let's update that too.
    if (variantData[0].compare_at_price != null) {
      productPrice.forEach(function (price) {
        price.classList.add("text-[#FF3D00]", "!font-semibold");
      });
      productCAPs.forEach(function (productCAP) {
        // If CAP does exist, remove the hidden class if present.
        productCAP.classList.remove("hidden");
        productDiscounts.forEach(function (discount) {
          discount.classList.remove("hidden");
          discount.innerHTML = 'SAVE ' + (0,_formatMoney__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(variantData[0].compare_at_price - variantData[0].price, window.theme.moneyFormat);
        });

        // Update the CAP, with the selected variant, and format the money.

        productCAP.innerHTML = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(variantData[0].compare_at_price, window.theme.moneyFormat);
      });
    } else {
      // No CAP?, No Problem, let's just hide it.
      productCAPs.forEach(function (productCAP) {
        productCAP.classList.add("hidden");
      });
      productPrice.forEach(function (price) {
        price.classList.remove("text-[#FF3D00]", "!font-semibold");
      });
      productDiscounts.forEach(function (discount) {
        discount.classList.add("hidden");
        discount.innerHTML = "";
      });
    }
  };

  /**
   * BG: Once the user has selected all variant options, this function then triggers to update the variant ID field, price and url based on the users choice.
   */
  var finalVariant = function finalVariant(variant) {
    //BG: let's update the id input to the selected variant id
    masterVariantField.value = variant.id;
    //BG: Trigger the price update based on the variant ID
    variantPrice(variant.id);
    //BG: Update the add to bag btn based on the variant being available or not.
    addToBagBtn(variant.available);
    //AS: Determine how much stock remains and hide/show the correct stock notification message.
    if (!document.querySelector(".js-pre-order")) {
      if (variant.available) {
        noStockNotification.classList.add("hidden");
        noStockNotification.classList.remove("flex");
        if (variant.inventory_quantity > 10) {
          inStockNotification.classList.remove("hidden");
          inStockNotification.classList.add("flex");
          lowStockNotification.classList.add("hidden");
          lowStockNotification.classList.remove("flex");
        } else {
          inStockNotification.classList.add("hidden");
          inStockNotification.classList.remove("flex");
          lowStockNotification.querySelector('.js-low-stock-number').textContent = "".concat(variant.inventory_quantity);
          lowStockNotification.classList.remove("hidden");
          lowStockNotification.classList.add("flex");
        }
      } else {
        inStockNotification.classList.add("hidden");
        inStockNotification.classList.remove("flex");
        lowStockNotification.classList.add("hidden");
        lowStockNotification.classList.remove("flex");
        noStockNotification.classList.remove("hidden");
        noStockNotification.classList.add("flex");
      }
    }
    ;

    //Update the url with the user's variant choice.
    //Get the current URL without parameters
    var currentURLWithoutParams = window.location.href.split("?")[0];
    //update the page url with paramters
    history.pushState(null, null, currentURLWithoutParams + "?variant=" + variant.id);
  };

  /**
   * BG: There's a lot going on here, basically we determine how many variant options there are, and based on how many options there are, will determine the logic and approach. Essentially, we're determining what options are available or not available based on the user's choice.
   * checkedBtns(Array) - Checked radio buttons.
   */
  var remainingOptions = function remainingOptions(checkedBtns) {
    //If only one variant, remove all unavailable classes.
    if (variantFieldsets.length === 1) {
      productVariants.querySelectorAll(".js-unavailable-variant").forEach(function (label) {
        label.classList.remove("js-unavailable-variant");
      });
    }

    // for each checked radio button.
    checkedBtns.forEach(function (radio, index) {
      //First fieldset option
      if (index === 0) {
        //console.log('fire option 1');
        var remainingVariants;
        //if only one variant, then find all the unavailable variants
        if (variantFieldsets.length === 1) {
          remainingVariants = getVariantData().filter(function (variant) {
            return variant.available === false;
          });
        } else if (variantFieldsets.length === 2) {
          //if two variants, then find all the variants from option1 that match the selected radio option, and sort by unavailable first.
          remainingVariants = getVariantData().filter(function (variant) {
            return variant.option1 === checkedBtns[0].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        } else if (variantFieldsets.length > 2) {
          //if three variants, find all the variants from option1 and option2 that match the selected values for 1 & 2, and sort by unavailable first.
          remainingVariants = getVariantData().filter(function (variant) {
            return variant.option1 === checkedBtns[0].value && variant.option2 === checkedBtns[1].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        }
        //console.log(index);
        //console.log({remainingVariants});
        remainingVariants.forEach(function (variant) {
          //if one variant, highlight the unavailable options.
          if (variantFieldsets.length === 1) {
            productVariants.querySelector(".js-variant-label[data-label-value='".concat(variant.option1, "']")).classList.add("js-unavailable-variant");
          }

          //if there is two variants, highlight the unavailable variants, and remove the class if the variant is available. During this array, we may come across the same item twice, therefore we sort by unavailable first to always ensure the available option is always highlighted at the end.
          if (variantFieldsets.length >= 2) {
            if (variant.available) {
              productVariants.querySelector(".js-variant-label[data-label-value='".concat(variant.option2, "']")).classList.remove("js-unavailable-variant");
            } else {
              productVariants.querySelector(".js-variant-label[data-label-value='".concat(variant.option2, "']")).classList.add("js-unavailable-variant");
            }
          }

          //if there is three variants, same as above.
          if (variantFieldsets.length > 2) {
            if (variant.available) {
              productVariants.querySelector(".js-variant-label[data-label-value='".concat(variant.option3, "']")).classList.remove("js-unavailable-variant");
            } else {
              productVariants.querySelector(".js-variant-label[data-label-value='".concat(variant.option3, "']")).classList.add("js-unavailable-variant");
            }
          }
        });
      }
      //Second Radio Option
      if (index === 1) {
        //console.log('fire option 2');
        var _remainingVariants;
        if (variantFieldsets.length === 2) {
          //if two variants, then find all the variants from option2 that match the selected radio option, and sort by unavailable first.
          _remainingVariants = getVariantData().filter(function (variant) {
            return variant.option2 === checkedBtns[1].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        } else if (variantFieldsets.length > 2) {
          //if three variants, find all the variants from option2 and option3 that match the selected values for 2 & 3, and sort by unavailable first.
          _remainingVariants = getVariantData().filter(function (variant) {
            return variant.option2 === checkedBtns[1].value && variant.option3 === checkedBtns[2].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        }
        //console.log(index);
        //console.log({remainingVariants});
        _remainingVariants.forEach(function (variant) {
          //if there is two variants, highlight the unavailable variants, and remove the class if the variant is available. During this array, we may come across the same item twice, therefore we sort by unavailable first to always ensure the available option is always highlighted at the end.
          if (variantFieldsets.length >= 2) {
            if (variant.available) {
              productVariants.querySelector(".js-variant-label[data-label-value='".concat(variant.option1, "']")).classList.remove("js-unavailable-variant");
            } else {
              productVariants.querySelector(".js-variant-label[data-label-value='".concat(variant.option1, "']")).classList.add("js-unavailable-variant");
            }
          }

          //if there is three variants, same as above.
          if (variantFieldsets.length > 2) {
            if (variant.available) {
              productVariants.querySelector(".js-variant-label[data-label-value='".concat(variant.option3, "']")).classList.remove("js-unavailable-variant");
            } else {
              productVariants.querySelector(".js-variant-label[data-label-value='".concat(variant.option3, "']")).classList.add("js-unavailable-variant");
            }
          }
        });
      }

      //Third Radio Option
      if (index === 2) {
        //console.log('fire option 3');
        //find all the variants from option3 and option1 that match the selected values for 3 & 1, and sort by unavailable first.
        var _remainingVariants2 = getVariantData().filter(function (variant) {
          return variant.option3 === checkedBtns[2].value && variant.option1 === checkedBtns[0].value;
        }).sort(function (variant) {
          return variant.available ? 1 : -1;
        });
        //console.log(index);
        //console.log({remainingVariants});
        _remainingVariants2.forEach(function (variant) {
          if (variant.available) {
            productVariants.querySelector(".js-variant-label[data-label-value='".concat(variant.option1, "']")).classList.remove("js-unavailable-variant");
          } else {
            productVariants.querySelector(".js-variant-label[data-label-value='".concat(variant.option1, "']")).classList.add("js-unavailable-variant");
          }
          if (variant.available) {
            productVariants.querySelector(".js-variant-label[data-label-value='".concat(variant.option2, "']")).classList.remove("js-unavailable-variant");
          } else {
            productVariants.querySelector(".js-variant-label[data-label-value='".concat(variant.option2, "']")).classList.add("js-unavailable-variant");
          }
        });
      }
    });
  };

  //BG: For each radio button, attach an event listener that triggers when it's checked/unchecked.
  radioBtns.forEach(function (radio, i) {
    return radio.addEventListener("change", function () {
      //After a selection has been made, gather all checked options.
      var radioBtnsChecked = productVariants.querySelectorAll('input[type="radio"]:checked');

      //By default, we assume there will always be one radio button checked.
      var optionCombine = radioBtnsChecked[0].value;
      //console.log(radioBtnsChecked[0].value);

      //if there are two variant fields, we assume there will be two checked radio btns so add this to the variable.
      if (variantFieldsets.length >= 2) {
        //console.log(radioBtnsChecked[1].value);
        optionCombine += " / " + radioBtnsChecked[1].value;
      }
      //if there are three variant fields, we assume there will be three checked radio btns so add this to the variable.
      if (variantFieldsets.length > 2) {
        //console.log(radioBtnsChecked[2].value);
        optionCombine += " / " + radioBtnsChecked[2].value;
      }

      //console.log({optionCombine});
      //BG: with the combined result we search for the variant based on the variant.title.
      var combineVariant = getVariantData().filter(function (variant) {
        return variant.title === optionCombine || variant.option1 === optionCombine;
      });
      if (!!combineVariant.length) {
        finalVariant(combineVariant[0]);
      } else {
        // console.error("No variant found");
      }
      fieldsetLegend(radio);
      remainingOptions(radioBtnsChecked);
      variantStock(i);
      if (!!stickyVariants) {
        stickyVariants.selectedIndex = i;
      }
      if (!!stickyVariantValue) {
        stickyVariantValue.innerHTML = "".concat(radioBtnsChecked[1].value.split(":")[0], " / ").concat(radioBtnsChecked[0].value);
      }
    });
  });
  var variantStock = function variantStock(index) {
    if (!!colourVariants) {
      colourVariants.forEach(function (variant) {
        if (!variant.classList.contains("is-current-variant")) {
          var variantUrl = variant.getAttribute("href");
          if (!!variantUrl) {
            fetch("".concat(variantUrl, "?view=availability")).then(function (response) {
              return response.json();
            }).then(function (data) {
              if (data.available != true) {
                variant.classList.add("variant-oos");
                variant.classList.add("opacity-50");
              } else {
                variant.classList.remove("variant-oos");
                variant.classList.remove("opacity-50");
              }
            });
          }
        }
      });
    }
  };
  radioBtns.forEach(function (radio, i) {
    if (radio.checked) {
      variantStock(i);
    }
  });
  var currentRadioBtnsChecked = productVariants.querySelectorAll('input[type="radio"]:checked');
  remainingOptions(currentRadioBtnsChecked);
  if (!!stickyVariants) {
    stickyVariants.addEventListener("change", function (i) {
      radioBtns[stickyVariants.selectedIndex].click();
    });
  }
};
var colourHover = function colourHover() {
  var colourVariants = document.querySelectorAll(".js-colour-variant");
  var colourVariantLabel = document.querySelector(".js-colour-variant-label");

  // display colour when hovering over colour variant
  if (colourVariants.length > 0) {
    colourVariants.forEach(function (colour) {
      colour.addEventListener("mouseover", function () {
        colourVariantLabel.querySelector("span").innerHTML = "".concat(colour.dataset.variantColour);
      });
      colour.addEventListener("mouseout", function () {
        colourVariantLabel.querySelector("span").innerHTML = "".concat(colourVariantLabel.dataset.currentVariant);
      });
      colour.addEventListener("click", function () {
        // Update the current variant label when a colour variant is clicked
        colourVariantLabel.dataset.currentVariant = colour.dataset.variantColour;
        colourVariantLabel.querySelector("span").innerHTML = "".concat(colour.dataset.variantColour);
      });
    });
  }
};

// Call the function to initialize the event listeners
colourHover();
var swatchHover = function swatchHover() {
  var swatches = document.querySelectorAll(".js-swatch");
  var swatchLabel = document.querySelector(".js-swatch-label");
  var swatchHoverLabel = document.querySelector(".js-swatch-hover-label");

  // display colour when hovering over colour variant
  if (!!swatches) {
    swatches.forEach(function (swatch) {
      swatch.addEventListener("mouseover", function () {
        swatchHoverLabel.innerHTML = swatch.getAttribute('data-swatch-colour-name');
        swatchLabel.classList.add('hidden');
      });
      swatch.addEventListener("mouseout", function () {
        swatchHoverLabel.innerHTML = '';
        swatchLabel.classList.remove('hidden');
      });
    });
  }
};

//only trigger the productVariants if there is more than one variant.
var variantSingle = document.querySelector(".single-variant");
var stickyBuy = function stickyBuy() {
  var paymentBtn = document.querySelector(".js-payment-button");
  var stickyBuy = document.querySelector(".js-sticky-buy");
  var stickyPayment = stickyBuy.querySelector("button");
  if (!!paymentBtn) {
    var options = {
      threshold: 0
    };
    var observer = new IntersectionObserver(function (entry) {
      if (entry[0].isIntersecting === false) {
        stickyBuy.classList.remove("translate-y-[100%]");
      } else {
        stickyBuy.classList.add("translate-y-[100%]");
      }
    }, options);
    observer.observe(paymentBtn);
    stickyPayment.addEventListener("click", function () {
      paymentBtn.click();
    });
  }
};

// Product Media toggle

document.addEventListener('DOMContentLoaded', function () {
  // Media toggle handled by core.js initPDPGallery()
});

// Product Description toggle

document.addEventListener('DOMContentLoaded', function () {
  var descriptionTitle = document.querySelector('.js-pdp-description-title');
  var descriptionContent = document.querySelector('.js-pdp-description');
  var descriptionClose = document.querySelector('.js-pdp-description-close');
  descriptionTitle.addEventListener('click', function () {
    if (descriptionContent.style.maxHeight === '0px' || descriptionContent.style.maxHeight === '') {
      descriptionContent.style.maxHeight = descriptionContent.scrollHeight + 'px';
      descriptionTitle.classList.add('hidden');
    } else {
      descriptionContent.style.maxHeight = '0px';
    }
  });
  descriptionClose.addEventListener('click', function () {
    descriptionContent.style.maxHeight = '0px';
    descriptionTitle.classList.remove('hidden');
  });
});
if (!variantSingle) {
  productVariants();
}

// Variant Gallery Sync - Updated for new scroll-based carousel system
document.addEventListener('DOMContentLoaded', function () {
  var productForm = document.querySelector('.pdp-form');
  if (!productForm) return;
  function scrollToVariantImage(variantId) {
    var carousel = document.querySelector('.pdp-carousel-container');
    var variantSlide = document.querySelector(".pdp-carousel-slide[data-variant-id=\"".concat(variantId, "\"]"));
    if (carousel && variantSlide) {
      var slideIndex = Array.from(carousel.children).indexOf(variantSlide);
      var scrollPosition = variantSlide.offsetLeft;
      carousel.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });
    }
  }
  var variantImgLabels = productForm.querySelectorAll('.js-variant-imgs');
  if (variantImgLabels) {
    variantImgLabels.forEach(function (variant) {
      variant.addEventListener('click', function () {
        var variantId = variant.getAttribute('data-variant-id');
        if (variantId) {
          scrollToVariantImage(variantId);
        }
      });
    });

    // Handle pre-selected variant on page load
    var urlParams = new URLSearchParams(window.location.search);
    var variantCheck = urlParams.get('variant');
    if (variantCheck) {
      setTimeout(function () {
        variantImgLabels.forEach(function (variant) {
          var input = variant.previousElementSibling;
          if (input && input.checked) {
            var variantId = variant.getAttribute('data-variant-id');
            if (variantId) {
              scrollToVariantImage(variantId);
            }
          }
        });
      }, 500);
    }
  }
});
colourHover();
swatchHover();
stickyBuy();
})();

/******/ })()
;